export function randomString(length: number = 16) {
  return crypto.randomUUID().replace(/-/g, '').slice(0, length);
}
